<template>
    <div v-if="visible" class="modal-overlay">
        <div
            class="modal-content"
            :class="{ 'modal-expanded': expandido }"
            role="dialog"
            aria-modal="true"
            aria-labelledby="titulo-justificativa"
        >
            <form @submit.prevent="onSubmit">
                <div class="modal-header">
                    <label
                        id="titulo-justificativa"
                        for="texto-justificativa"
                        class="label-caption"
                    >
                        Justificativa
                    </label>

                    <button
                        type="button"
                        class="btn-small"
                        :aria-expanded="expandido"
                        aria-controls="texto-justificativa"
                        @click="expandido = !expandido"
                    >
                        {{ expandido ? 'Reduzir ↙' : 'Expandir ↗' }}
                    </button>
                </div>

                <textarea
                    id="texto-justificativa"
                    v-model="edJustificativa"
                    :maxlength="limiteTexto > 0 ? limiteTexto : undefined"
                    :rows="expandido ? 15 : 5"
                    aria-describedby="contador-justificativa"
                ></textarea>

                <div
                    id="contador-justificativa"
                    class="character-count"
                    :class="{ 'limit-reached': limiteTexto > 0 && restantes === 0 }"
                >
                    <template v-if="limiteTexto > 0">
                        {{ restantes }}
                        {{ restantes === 1 ? 'caractere disponível' : 'caracteres disponíveis' }}
                        de {{ limiteTexto }}
                    </template>
                    <template v-else>
                        {{ edJustificativa.length }} caracteres · Sem limite
                    </template>
                </div>

                <div class="row-end modal-actions">
                    <button
                        type="button"
                        class="btn-small"
                        @click="closeModal"
                    >
                        Voltar
                    </button>

                    <button type="submit" class="btn-small btn-save">
                        Confirmar
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    textLength: { type: Number, default: 500 },
});

const limiteTexto = ref(0);
const visible = ref(false);
const edJustificativa = ref('');
const expandido = ref(false);

let resolvePromise = null;

const restantes = computed(() =>
    Math.max(0, limiteTexto.value - edJustificativa.value.length)
);

const show = (opcoes = {}) => {
    limiteTexto.value = opcoes.textLength ?? props.textLength;
    edJustificativa.value = '';
    expandido.value = false;
    visible.value = true;

    return new Promise((resolve) => {
        resolvePromise = resolve;
    });
};

const onSubmit = () => {
    finalizar({
        confirmado: true,
        justificativa: edJustificativa.value,
    });
};

const closeModal = () => {
    finalizar({
        confirmado: false,
        justificativa: null,
    });
};

function finalizar(resultado) {
    visible.value = false;

    const resolve = resolvePromise;
    resolvePromise = null;
    resolve?.(resultado);
}

defineExpose({ show });
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    box-sizing: border-box;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 600px;
    max-width: 100%;
    max-height: calc(100dvh - 32px);
    overflow-y: auto;
    box-sizing: border-box;
    transition: width 0.2s ease;
}

.modal-content.modal-expanded {
    width: 1000px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
}

textarea {
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font: inherit;
    line-height: 1.5;
    resize: vertical;
}

textarea:focus {
    outline: 2px solid #1e3a8a;
    outline-offset: 2px;
}

.character-count {
    margin-top: 6px;
    font-size: 12px;
    text-align: right;
    color: #64748b;
}

.limit-reached {
    color: #b45309;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
}
</style>